import { api } from '@/api';
import { queryOptions } from '@tanstack/react-query';
import { getQueryKeysFactory } from './queryKeysFactory';

export const getPreviewOrganizationQuery = (params: {
  organizationId?: string;
  invitationCode?: string;
}) => {
  const { organizationKeys } = getQueryKeysFactory();

  return queryOptions({
    queryKey: organizationKeys.previewOrganization(params.invitationCode),
    queryFn: async () => {
      const response = await api.PreviewOrganization({
        organizationId: params.organizationId as string,
        invitationCode: params.invitationCode as string,
      });

      return response.data;
    },
    enabled: !!params.invitationCode && !!params.organizationId,
  });
};
